import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AppSettingsService, ArrayResponse, BaseRestService, SendBackResult, serializeQueryString} from '../../shared';
import {ContractFilter} from '../models/contract-filter';
import {ContractItem} from '../models/contract-item';
import {Contract} from '../models/contract';
import {CurrencyObject} from '../models/currency';

@Injectable({ providedIn: 'root' })
export class ContractService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService) {
    super(http, appSettingsService);
  }

  protected get className(): string {
    return 'ContractService';
  }

  protected get isAnonymous(): boolean {
    return false;
  }

  getList(uuid: string, filter: ContractFilter): Observable<SendBackResult<ArrayResponse<ContractItem>>> {
    if (uuid) {
      return this.get<ArrayResponse<ContractItem>>(`/company/${uuid}/contracts${serializeQueryString(filter)}`);
    }
  }
  getSiteListContract(uuid: string, filter: ContractFilter): Observable<SendBackResult<ArrayResponse<ContractItem>>> {
    if (uuid) {
      return this.get<ArrayResponse<ContractItem>>(`/Site/${uuid}/contracts${serializeQueryString(filter)}`);
    }
  }
  getSiteSubscriptionListContract(uuid: string, filter: ContractFilter): Observable<SendBackResult<ArrayResponse<ContractItem>>> {
    if (uuid) {
      return this.get<ArrayResponse<ContractItem>>(`/Subscription/${uuid}/contracts${serializeQueryString(filter)}`);
    }
  }
  load(contractUuid: string): Observable<SendBackResult<Contract>> {
    return this.get<Contract>(`/contract/${contractUuid}`);
  }
  loadCurrency(): Observable<SendBackResult<ArrayResponse<CurrencyObject>>> {
    return this.get<ArrayResponse<CurrencyObject>>(`/Currencies`);
  }

  add(companyUuid: string, contract: Contract): Observable<SendBackResult<Contract>> {
    if (contract.uuid) {
      return this.put<Contract>(`/Company/${companyUuid}/contract/${contract.uuid}`, contract );
    } else {
      return this.post<Contract>(`/Company/${companyUuid}/contract`, contract );
    }
  }
  // tslint:disable-next-line:no-any
  patchComment( contract: any): Observable<SendBackResult<Contract>> {
      return this.put<Contract>(`/Contract/${contract.uuid}/Comments`, contract );
  }
}
